import { DirectionDocTranslated, DocumentTypeTranslated } from '../../../types/Invoice';
import ListButton, { ListButtonEntityType } from '../../listButton/ListButton';
import { TableColumn } from '../../table/DataTable.types';

export const columns = (): TableColumn[] => [
  {
    accessor: 'direction',
    name: 'page.invoice.col-direction',
    hideFilter: true,
    translateEnum: DirectionDocTranslated,
  },
  {
    accessor: 'type',
    name: 'page.invoice.col-type',
    translateEnum: DocumentTypeTranslated,
  },
  {
    accessor: 'documentNumber',
    name: 'page.invoice.col-doc-number',
    hideFilter: true,
  },
  {
    accessor: 'documentStatus',
    name: 'page.invoice.col-doc-status',
    className: `whitespace-nowrap`,
    cellRenderer(e) {
      return (
        <ListButton params={e.documentStatus} entityType={ListButtonEntityType.DOCUMENT_STATUS} />
      );
    },
  },
];
